export function getView(value) {
  return value === 'emploProfessionalRelationship'
    ? 'DataVaxiomEmployeeProfessionalsRelationshipsItem'
    : 'DataVaxiomOtherProfessionalsRelationshipsItem'
}
